import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { Table, Button, Icon, Modal, Form, Header, Image } from "semantic-ui-react";

import Container from "../../components/Container/Container";

import { fetchInvestors, deleteInvestor, updateInvestor } from "../../redux/actions/user";
import styles from "./ManageInvestorsScreen.module.css";

const ManageInvestorsScreen = ({ user, investors, dispatch }) => {
    const [loading, setLoading] = useState(true);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedInvestor, setSelectedInvestor] = useState(null);
    const [editData, setEditData] = useState({ nom: "", prenom: "", pourcentage: "" });

    const loadInvestors = useCallback(async () => {
        setLoading(true);
        try {
            await dispatch(fetchInvestors());
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    }, [dispatch]);

    useEffect(() => {
        loadInvestors();
    }, [loadInvestors]);

    const handleDelete = async (investorId) => {
        if (!window.confirm("Êtes-vous sûr de vouloir supprimer cet investisseur ?")) return;
        const success = await dispatch(deleteInvestor(investorId));
        if (success) {
            alert("Investisseur supprimé avec succès.");
            loadInvestors();
        } else {
            alert("Erreur lors de la suppression.");
        }
    };

    const handleEditOpen = (investor) => {
        setSelectedInvestor(investor);
        setEditData({
            nom: investor.lastName || investor.nom || "",
            prenom: investor.name || investor.prenom || "",
            pourcentage: investor.profile?.percentage || ""
        });
        setEditModalOpen(true);
    };

    const handleEditSubmit = async () => {
        const success = await dispatch(updateInvestor(selectedInvestor.id || selectedInvestor._id, {
            lastName: editData.nom,
            name: editData.prenom,
            percentage: parseFloat(editData.pourcentage)
        }));

        if (success) {
            alert("Investisseur mis à jour !");
            setEditModalOpen(false);
            loadInvestors();
        } else {
            alert("Erreur lors de la mise à jour.");
        }
    };

    return (
        <Container title="Gestion Investisseurs">
            <div className={styles.container}>

                <div className={styles.logoContainer}>
                    <Image src={"/logo3_1.png"} className={styles.logo} />
                    <Header as="h2" textAlign="center" className={styles.title}>
                        Gestion des Investisseurs
                    </Header>
                </div>

                <div className={styles.tableContainer}>
                    {loading ? (
                        <p>Chargement des investisseurs...</p>
                    ) : investors.length === 0 ? (
                        <p>Aucun investisseur trouvé.</p>
                    ) : (
                        <Table celled unstackable className={styles.table}>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Nom</Table.HeaderCell>
                                    <Table.HeaderCell>Prénom</Table.HeaderCell>
                                    <Table.HeaderCell>Téléphone</Table.HeaderCell>
                                    <Table.HeaderCell>Pourcentage (%)</Table.HeaderCell>
                                    <Table.HeaderCell>Actions</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {investors.map(inv => (
                                    <Table.Row key={inv.id || inv._id}>
                                        <Table.Cell>{inv.lastName || inv.nom}</Table.Cell>
                                        <Table.Cell>{inv.name || inv.prenom}</Table.Cell>
                                        <Table.Cell>{inv.phone}</Table.Cell>
                                        <Table.Cell>{inv.profile?.percentage || 0}%</Table.Cell>
                                        <Table.Cell>
                                            <Button icon color="blue" size="small" onClick={() => handleEditOpen(inv)}>
                                                <Icon name="edit" />
                                            </Button>
                                            <Button icon color="red" size="small" onClick={() => handleDelete(inv.id || inv._id)}>
                                                <Icon name="trash" />
                                            </Button>
                                        </Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    )}
                </div>

                <Modal open={editModalOpen} onClose={() => setEditModalOpen(false)} size="tiny">
                    <Modal.Header>Éditer Investisseur</Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Input
                                label="Nom"
                                value={editData.nom}
                                onChange={(e) => setEditData({ ...editData, nom: e.target.value })}
                            />
                            <Form.Input
                                label="Prénom"
                                value={editData.prenom}
                                onChange={(e) => setEditData({ ...editData, prenom: e.target.value })}
                            />
                            <Form.Input
                                label="Pourcentage (%)"
                                type="number"
                                value={editData.pourcentage}
                                onChange={(e) => setEditData({ ...editData, pourcentage: e.target.value })}
                            />
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => setEditModalOpen(false)}>Annuler</Button>
                        <Button color="green" onClick={handleEditSubmit}>Sauvegarder</Button>
                    </Modal.Actions>
                </Modal>

            </div>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    user: state.user,
    investors: state.user.listInvestors
});

export default connect(mapStateToProps)(ManageInvestorsScreen);
